import { createAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';

export interface UpdateCategoryAction {
    name: string;
    modify: 'hidden' | 'disabled' | null;
}

export const updateCategoryAction = createAction<
    ActionType,
    UpdateCategoryAction
>(ActionType.NOTI__EC__UPDATE_CATEGORY_ACTION);
